// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__5qb1C","label":"Category_label__2Cquf","content":"Category_content__1jVVj","header":"Category_header__1kzjE","location":"Category_location__2rJZs"};